module.exports = __webpack_public_path__ + "static/accordionBack-93d5f6b354c19b72e8cce405655ff26f.png";